import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ✅ ONE place to read token
function getAuthHeaders() {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("demo-token");

  if (!token) return {};

  // If your backend expects "JWT <token>" instead of "Bearer <token>",
  // change 'Bearer' to 'JWT' here.
  return {
    Authorization: `Bearer ${token}`,
  };
}

export const updateUserProfile = async (formData) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeaders(),
      },
    };

    const { data } = await api.put(
      `${API_BASE_URL}api/users/profile`,
      formData,
      config
    );
    return { success: true, data };
  } catch (error) {
    console.error("❌ API error:", error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.message || "Update failed",
    };
  }
};

export const getUserProfile = async () => {
  try {
    const config = {
      headers: {
        ...getAuthHeaders(),
        "Accept-Language": localStorage.getItem("lang") || "en",
      },
    };
    const { data } = await api.get(`${API_BASE_URL}api/users/profile`, config);
    return { success: true, data };
  } catch (error) {
    console.error(
      "❌ getUserProfile error:",
      error.response?.data || error.message
    );
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch user",
    };
  }
};

export const deleteUser = async () => {
  try {
    const config = {
      headers: {
        ...getAuthHeaders(),
      },
    };

    const response = await api.delete(
      `${API_BASE_URL}api/users/profile`,
      config
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || "Delete failed",
    };
  }
};

export const exportProductsExcel = async (params = {}) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": localStorage.getItem("lang") || "en",
    },
    responseType: "blob",
    params,
  };
  const url = `${API_BASE_URL}api/products/export`;
  return api.get(url, config);
};

export async function getTenantLimitsUsage(vendorStoreId) {
  try {
    const { data } = await api.get(`/usage/limits/${vendorStoreId}`);
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.error || e.message };
  }
}

// STAFF Management API

export async function createStaffUser(payload) {
  try {
    const { data } = await api.post(`${API_BASE_URL}api/users/role`, payload, {
      headers: getAuthHeaders(),
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
export async function listStaffUsers() {
  try {
    const { data } = await api.get(`${API_BASE_URL}api/users/role`, {
      headers: getAuthHeaders(),
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
export async function updateStaffUser(id, payload) {
  try {
    const { data } = await api.put(
      `${API_BASE_URL}api/users/role/${id}`,
      payload,
      {
        headers: getAuthHeaders(),
      }
    );
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
export async function deleteStaffUser(id) {
  try {
    const { data } = await api.delete(`${API_BASE_URL}api/users/role/${id}`, {
      headers: getAuthHeaders(),
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
